import { memo } from 'react';
import { Box, Paper, Typography, Skeleton } from '@mui/material';
import { MapPin, CheckCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import Map, { Marker } from 'react-map-gl/mapbox';
import 'mapbox-gl/dist/mapbox-gl.css';

const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;

function MiniMap({ latitude, longitude }) {
  return (
    <Map
      mapboxAccessToken={MAPBOX_TOKEN}
      initialViewState={{ longitude, latitude, zoom: 14 }}
      style={{ width: '100%', height: '100%' }}
      mapStyle="mapbox://styles/mapbox/light-v11"
    >
      <Marker longitude={longitude} latitude={latitude} color="#EF4444" />
    </Map>
  );
}

const AddressBlock = memo(function AddressBlock({
  validatedAddress,
  addressInfo,
}) {
  const hasGeo = addressInfo?.address_latitude && addressInfo?.address_longitude;

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <Paper
        elevation={0}
        sx={{
          borderRadius: '12px',
          border: '1px solid #E2E8F0',
          overflow: 'hidden',
        }}
      >
        <Box sx={{ p: 2.5, display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: '8px',
              backgroundColor: '#F0FDF4',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            {validatedAddress ? (
              <CheckCircle size={18} color='#10B981' />
            ) : (
              <MapPin size={18} color='#94A3B8' />
            )}
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant='caption'
              sx={{
                color: '#64748B',
                fontFamily: '"Lato", sans-serif',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                fontSize: '11px',
              }}
            >
              Verified Address
            </Typography>
            {validatedAddress ? (
              <Typography
                sx={{
                  color: '#1E293B',
                  fontFamily: '"Lato", sans-serif',
                  fontWeight: 700,
                  fontSize: '15px',
                  mt: 0.25,
                }}
              >
                {validatedAddress}
              </Typography>
            ) : (
              <Skeleton variant='text' width='80%' sx={{ mt: 0.5 }} />
            )}
            {hasGeo && (
              <Typography
                variant='caption'
                sx={{
                  color: '#94A3B8',
                  fontFamily: '"Lato", sans-serif',
                  fontSize: '12px',
                }}
              >
                {addressInfo.address_latitude.toFixed(5)},{' '}
                {addressInfo.address_longitude.toFixed(5)}
              </Typography>
            )}
          </Box>
        </Box>

        {hasGeo && (
          <Box sx={{ height: 200, borderTop: '1px solid #F1F5F9' }}>
            <MiniMap
              latitude={addressInfo.address_latitude}
              longitude={addressInfo.address_longitude}
            />
          </Box>
        )}
      </Paper>
    </motion.div>
  );
});

export default AddressBlock;
